// Hook edycji komentarza do oferty (nagłówka).
// PUT /sales-crm/clients/:cid/offers/:oid/comments/:commentId

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IPutSalesCrmOfferCommentPayload {
  comment?: string;
  isVisibleForClient?: boolean;
}

export interface IPutSalesCrmOfferCommentVariables {
  commentId: number;
  payload: IPutSalesCrmOfferCommentPayload;
}

type IResponse = ICommandResponseSuccess;

const putSalesCrmOfferComment = (
  clientId: number,
  offerId: string,
  commentId: number,
  payload: IPutSalesCrmOfferCommentPayload
): Promise<IResponse> =>
  axios.put(
    `/sales-crm/clients/${clientId}/offers/${offerId}/comments/${commentId}`,
    payload
  );

export const usePutSalesCrmOfferComment = (
  clientId: number,
  offerId: string,
  options?: UseMutationOptions<IResponse, IError, IPutSalesCrmOfferCommentVariables>
) =>
  useMutation(
    ({ commentId, payload }: IPutSalesCrmOfferCommentVariables) =>
      putSalesCrmOfferComment(clientId, offerId, commentId, payload),
    options
  );
